/*
 * @Author: 陈希cici chenxi@cspm.com.cn
 * @Date: 2024-01-09 16:54:19
 * @LastEditors: 陈希cici chenxi@cspm.com.cn
 * @LastEditTime: 2024-07-24 10:44:12
 * @FilePath: \editor_reader\src\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'

// 获取消息列表
export function messageListApi(params) {
  return request({
    url: `/msg-notice/page`,
    method: 'get',
    params
  })
}

// 未读消息数量
export function unreadMessageCountApi(params) {
  return request({
    url: `/msg-notice/count`,
    method: 'get',
    params
  })
}

// 标记已读
export function readMessageApi(params) {
  return request({
    url: `/msg-notice/read`,
    method: 'get',
    params
  })
}
// 获取隐私政策
export function getSite() {
  return request({
    url: `/api/site`,
    method: 'get'
  })
}

// 获取隐私政策详情
export function getBlogDetail(id) {
  return request({
    url: `/api/site/imageText/${id}`,
    method: 'get'
  })
}

// 校验消息是否可以跳转
export function checkMessageApi(params) {
  return request({
    url: `/msg-notice/check`,
    method: 'get',
    params
  })
}

// 获取更新信息
export function getUpdateVersion(data) {
  return request({
    url: `/api/version/check`,
    method: "post",
    data
  });
}

// 获取更新信息列表
export function getVersion(params) {
  return request({
    url: `/api/version/page`,
    method: "get",
    params,
  });
}
